import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import {PropagandaModel} from 'model/api/gestao/propaganda/propaganda-model';

export function usePostCadastrarPropaganda() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postCadastrarPropaganda = useCallback(
        (propaganda: PropagandaModel) =>
            invocarApi({
                url: `/v1/Propagandas`,
                method: 'POST',
                data: propaganda,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                enviarTokenUsuario: true,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postCadastrarPropaganda,
    };
}
